export const SITE_ORIGIN = "https://theplantbasedswitch.com";
export const DEFAULT_SHARE_IMAGE = `${SITE_ORIGIN}/Images/hero-pbs-desktop.webp`;
export const TWITTER_HANDLE = "@theplantbasedswitch";

export function canonicalUrl(path = "/") {
  if (!path || path === "/") return `${SITE_ORIGIN}/`;
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_ORIGIN}${clean.split("?")[0].replace(/\/+$/, "")}`;
}

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href, extra = {}) {
  const extraSelector = Object.entries(extra)
    .map(([name, value]) => `[${name}="${value}"]`)
    .join("");
  let el = document.head.querySelector(`link[rel="${rel}"]${extraSelector}`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    Object.entries(extra).forEach(([name, value]) => el.setAttribute(name, value));
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/** Keep title, social tags, canonical, robots, and hreflang aligned with the current page. */
export function applyPageMeta({
  title,
  description,
  path = "/",
  image,
  type = "website",
}) {
  const url = canonicalUrl(path);
  const shareImage = image || DEFAULT_SHARE_IMAGE;

  document.title = title;
  upsertMeta("name", "description", description);
  upsertMeta("name", "robots", "index, follow");

  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:type", type);
  upsertMeta("property", "og:url", url);
  upsertMeta("property", "og:image", shareImage);
  upsertMeta("property", "og:site_name", "The Plant-Based Switch");

  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:site", TWITTER_HANDLE);
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", shareImage);

  upsertLink("canonical", url);
  upsertLink("alternate", url, { hreflang: "en" });
  upsertLink("alternate", url, { hreflang: "x-default" });
}

export function plainTextExcerpt(html, max = 160) {
  const text = String(html || "")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\s+/g, " ")
    .trim();
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1).trim()}…`;
}
